hrd.utils.CountdownTimer = hrd.Class.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.utils.CountdownTimer',
			delay: 1000,
			startTimestamp: undefined,
			duration: 15,
			unit: 'minutes', //minutes, seconds, hours			
		};
		this._super($.extend(true, {}, defaults, options));
	},
	start: function() {
		const deferred = $.Deferred();
		// initializations
		let startTimestamp = this.settings.startTimestamp || moment();
		let duration = this.settings.duration;
		let countdown = moment.duration(duration, this.settings.unit);
		let conditionFn = (countdown) => (countdown.asSeconds() > 1);
		let bodyFn = (countdown, startTimestamp, duration) => this.updateTimer(countdown, startTimestamp, duration);

		try {
			this.promiseWhile(conditionFn, bodyFn, countdown, startTimestamp, duration)
				.progress(deferred.notify)
				.then(function() {
					deferred.resolve();
				});
		} catch (e) {
			console.log(e);
		}
		return deferred.promise();
	},
	updateTimer: function(countdown, startTimestamp, duration) {
		const deferred = $.Deferred();
		$.timeout(this.settings.delay)
			.then(() => {
				let timerLimit = moment.duration(duration, this.settings.unit);
				let currentDuration = moment.duration(moment().diff(startTimestamp));
				countdown = timerLimit.subtract(currentDuration);
				deferred.notify(countdown);
				deferred.resolve(countdown, startTimestamp, duration);
			});
		return deferred.promise();
	},
	promiseWhile: function(condition, body) {
		var extraargs = Array.prototype.slice.call(arguments, 2);
		const done = $.Deferred();

		function loop() {
			var args = Array.prototype.slice.call(arguments, 0);
			// When the result of calling `condition` is no longer true, we are done.
			if (!condition.apply(null, args)) return done.resolve();
			// Use `when`, in case `body` does not return a promise.
			// When it completes loop again otherwise, if it fails, reject the done promise
			$.when(body.apply(null, args)).progress(done.notify).then(loop, done.reject);
		}

		// Start running the loop in the next tick so that this function is
		// completely async. It would be unexpected if `body` was called
		// synchronously the first time.
		$.timeout(0).then(loop.apply(null, extraargs));

		// The promise
		return done.promise();
	}	
});